<template>
  <!--  <basic-container>-->
  <div id="plan" v-loading="pageLoading">
    <!-- 基础信息 -->
    <div class="grid">
      <div class="grid-title">
        <i class="el-icon-success"></i>
        <span>基础信息</span>
        <hr />
      </div>
      <el-form ref="cttfm" :model="ruleForm" :rules="rules" label-width="100px">
        <!--  -->
        <el-row>
          <el-col span="12">
            <el-form-item label="项目名称" prop="projectId">
              <el-select
                style="width: 100%"
                v-model="ruleForm.projectId"
                placeholder="项目名称"
                :disabled="pageMode == 0"
                @change="testChange"
              >
                <el-option
                  v-for="(item, index) in projectList"
                  :key="index"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col span="12">
            <el-form-item label="合同对象" prop="partnerId">
              <avue-input-tree
                default-expand-all
                v-model="ruleForm.partnerId"
                placeholder="请选择 合同对象"
                type="tree"
                :dic="partnerList"
                :disabled="pageMode == 0"
                :props="{ label: 'name', value: 'id' }"
                style="width: 100%"
              ></avue-input-tree>
            </el-form-item>
          </el-col>
        </el-row>
        <!--  -->
        <el-row>
          <el-col span="12">
            <el-form-item label="合同编号" prop="code">
              <el-input
                type="text"
                v-model="ruleForm.code"
                placeholder="合同编号"
                :disabled="pageMode == 0"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col span="12">
            <el-form-item label="合同名称" prop="name">
              <el-input
                type="text"
                v-model="ruleForm.name"
                placeholder="合同名称"
                :disabled="pageMode == 0"
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col span="12">
            <el-form-item label="合同类型" prop="type">
              <el-select
                style="width: 100%"
                v-model="ruleForm.type"
                placeholder="合同类型"
                :disabled="pageMode == 0"
              >
                <el-option
                  v-for="(item, index) in dictData.contractTypeList"
                  :key="index"
                  :label="item.dictValue"
                  :value="item.dictKey"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col span="12">
            <el-form-item label="签订日期" prop="signTime">
              <el-date-picker
                type="date"
                placeholder="选择日期"
                v-model="ruleForm.signTime"
                style="width: 100%"
                :disabled="pageMode == 0"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col span="6">
            <el-form-item label="生效日期" prop="validityPeriodStart">
              <el-date-picker
                type="date"
                v-model="ruleForm.validityPeriodStart"
                placeholder="请选择生效日期"
                style="width: 100%"
                :disabled="pageMode == 0"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col span="6">
            <el-form-item
              label="有效期至"
              prop="validityPeriodEnd"
              :error="validityPeriodEndError"
              errorMessage=""
            >
              <el-date-picker
                type="date"
                v-model="ruleForm.validityPeriodEnd"
                placeholder="请选择有效期"
                style="width: 100%"
                :disabled="pageMode == 0"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col span="12">
            <el-form-item label="质保期至" prop="warrantyPeriodEnd">
              <el-date-picker
                type="date"
                placeholder="选择日期"
                v-model="ruleForm.warrantyPeriodEnd"
                style="width: 100%"
                :disabled="pageMode == 0"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <!--  -->
        <el-form-item label="收付款类型" prop="paymentType">
          <el-radio
            v-for="(item, index) in dictData.paymentTypeList"
            :key="index"
            v-model="ruleForm.paymentType"
            :disabled="pageMode == 0"
            :label="item.dictKey"
            >{{ item.dictValue }}
          </el-radio>
        </el-form-item>
        <!--  -->
        <el-row>
          <el-col span="12">
            <el-form-item label="合同金额" prop="money">
              <el-input
                type="number"
                v-model="ruleForm.money"
                placeholder="合同金额"
                :disabled="pageMode == 0"
              />
            </el-form-item>
          </el-col>
          <el-col span="12">
            <el-form-item label="允许超额" prop="overflowFlag">
              <el-radio
                v-model="ruleForm.overflowFlag"
                :disabled="pageMode == 0"
                label="1"
                >允许
              </el-radio>
              <el-radio
                v-model="ruleForm.overflowFlag"
                :disabled="pageMode == 0"
                label="0"
                >不允许
              </el-radio>
            </el-form-item>
          </el-col>
        </el-row>
        <!--  -->
        <el-row>
          <el-col span="12">
            <el-form-item label="签订部门" prop="signDept">
              <el-input
                v-model="ruleForm.signDept"
                placeholder="签订部门"
                :disabled="pageMode == 0"
              />
            </el-form-item>
          </el-col>
          <el-col span="12">
            <el-form-item label="责任人" prop="userIds">
              <!-- <template slot="userIds" slot-scope="scope"> -->
              <!-- <el-input
                readonly
                v-model="ruleForm.userIds"
                style="display: none"
              ></el-input>
              <el-input
                @focus="editUserBox(scope)"
                v-model="formUserNames"
                autosize
                type="textarea"
                :disabled="pageMode == 0"
              ></el-input> -->
              <UserEditBox2
                v-model="ruleForm.userIds"
                :remainUserListInside.sync="remainUserList"
                :projectId="ruleForm.projectId"
                :disabled="pageMode == 0"
                :limit="1"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <!--  -->
        <el-row>
          <el-col span="24">
            <el-form-item label="备注" prop="description">
              <el-input
                type="textarea"
                :rows="3"
                :maxlength="200"
                :show-word-limit="true"
                v-model="ruleForm.description"
                placeholder="备注"
                :disabled="pageMode == 0"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <!--  -->
        <el-form-item label="关联合同" prop="desc">
          <div>
            <el-button type="primary" @click="addRelativeContract">
              <i class="el-icon-plus" v-if="pageMode == 1">添加关联合同</i>
              <i class="el-icon-edit" v-else>修改关联合同</i>
            </el-button>
            <RelativeContract
              ref="relativeContract"
              :projectId="ruleForm.projectId"
              :contractLifecycle="dictData.contractLifecycle"
              :pageMode="pageMode"
              @result="relativeContractResult"
            />
          </div>
        </el-form-item>
        <!--  -->
        <el-form-item label="">
          <el-table border :data="relativeContracts.choosen">
            <el-table-column prop="name" label="合同名称"></el-table-column>
            <el-table-column prop="code" label="合同编号"></el-table-column>
            <el-table-column label="合同对象">
              <template slot-scope="scope">
                {{ partnerName(scope.row.partnerId) }}
              </template>
            </el-table-column>
            <el-table-column label="合同状态">
              <template slot-scope="scope">
                {{ contractStatus(scope.row.lifecycleIndex) }}
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
        <!--  -->
        <el-form-item label="合同描述" v-if="pageMode != 0">
          <AvueUeditor
            v-model="ruleForm.content2"
            :options="avueUeditorOptions"
          ></AvueUeditor>
        </el-form-item>
        <el-form-item label="合同描述" v-if="pageMode == 0">
          <div
            style="padding: 10px; border: 1px solid #efefef"
            v-html="ruleForm.content2"
          ></div>
        </el-form-item>
      </el-form>
    </div>
    <!-- 合同附件 -->
    <div style="height: 5px"></div>
    <!-- 合同附件 -->
    <div class="grid">
      <div class="grid-title">
        <i class="el-icon-success"></i>
        <span>合同附件</span>
        <hr />
      </div>

      <div class="upload-box">
        <VUpload :fileList.sync="ruleForm.fileList" :disabled="pageMode == 0" />
      </div>
    </div>
    <!--  -->
    <div style="height: 5px"></div>
    <div class="grid save" v-if="pageMode != 0">
      <el-button type="primary" @click="save">保存</el-button>
    </div>
    <!-- 人员选择 -->
    <el-dialog
      title="请选择人员"
      :visible.sync="dialogUserEditBoxVisible"
      append-to-body
      :modal-append-to-body="false"
      width="80%"
      :close-on-click-modal="false"
    >
      <user-edit-box
        v-if="dialogUserEditBoxVisible && userEditBoxProjectId"
        @closeAction="handleCloseAction"
        @submitAction="handleSubmitAction"
        @editAction="handleEditAction"
        :selectType="selectUserType"
        :handleAction="handleAction"
        :remainUserListInside="remainUserList"
        :projectId="userEditBoxProjectId"
        
        :limit='1'
      />
    </el-dialog>
  </div>
  <!--  </basic-container>-->
</template>

<script>
import {
  saveContract,
  editContract,
  getDictData,
  getBisDictData,
  getContractDetail,
  getProjectList,
  getPartnerList,
  userList,
  updateLinkContract,
} from "@/api/crmedical/contract/add";

import { vString, vMoney } from "@/util/validate";

import { formatTime, modifyDictData } from "@/util/apputil";

import VUpload from "@/views/components/v-upload.vue";
// import userEditBox from "@/views/crmedical/group/user-edit-box";
import UserEditBox2 from '@/components/user-edit-box/user-edit-box2';
import RelativeContract from "../components/relative-contract";

import { Base64 } from "js-base64";
import treeVue from "../../../../../packages/config/tree.vue";

export default {
  components: { VUpload, UserEditBox2, RelativeContract },
  props: {
    //0-查看;1-新增,2-编辑
    pageMode: {
      type: Number,
      default: 1,
    },
    id: {
      type: String,
      default: "",
    },
  },
  data() {
    var validatePass = (rule, value, callback) => {
      let reg = /^([0-9]|[1-9][0-9]{0,8})(\.[1-9]|\.[0-9]{1,2})?$/;
      if (reg.test(value)) {
        callback();
      } else {
        callback(new Error('请输入小数点前9位后2位小数的金额'));
      }
    };
    return {
      //人员选择
      dialogUserEditBoxVisible: false, //显隐
      userEditBoxProjectId: "", //项目id
      selectUserType: "",
      remainUserList: [],
      handleAction: "",
      formUserNames: "",
      //人员选择end
      showRelativeContracts: false,
      // 系统字典数据
      dictData: {
        contractTypeList: [],
        paymentTypeList: [],
        contractLifecycle: [],
      },
      // 业务列表
      projectList: [],
      partnerList: [],
      userList: [],
      //
      pageLoading: false,
      partnerListLoading: false,
      // 表单数据
      validityPeriodEndError: false,
      ruleForm: {
        id: null,
        projectId: "",
        type: "",
        code: "",
        partnerId: "",
        partnerName: "",
        chargeManName: "",
        signTime: "",
        validityPeriodStart: "",
        validityPeriodEnd: "",
        warrantyPeriodEnd: "", //质保期止
        paymentType: "",
        money: "",
        overflowFlag: "",
        signDept: "",
        chargeManId: "",
        content: "", //富文本 base64
        content2: "", //富文本
        fileList: [], // 上传附件列表
      },
      // 富文本配置
      avueUeditorOptions: {
        customConfig: {
          menus: [
            "head", // 标题
            "bold", // 粗体
            "fontSize", // 字号
            "fontName", // 字体
            "italic", // 斜体
            "underline", // 下划线
            "strikeThrough", // 删除线
            "foreColor", // 文字颜色
            "backColor", // 背景颜色
            "link", // 插入链接
            "list", // 列表
            "justify", // 对齐方式
            "quote", // 引用
            "emoticon", // 表情
            // 'image',  // 插入图片
            "table", // 表格
            // 'video',  // 插入视频
            "code", // 插入代码
            "undo", // 撤销
            "redo", // 重复
          ],
        },
      },
      // 关联合同列表搜索表单
      relativeContractSearchForm: { input: "" },
      // 搜索表单节流
      debounce: "",
      // 关联合同相关
      relativeContracts: {
        show: false,
        choosen: [], //已选关联合同
        list: [], //关联合同列表
        current: 1,
        total: 0,
      },
      cloneChoosen: [],
      // 表单校验规则
      rules: {
        projectId: [
          { required: true, message: "请选择项目名称", trigger: "blur" },
        ],
        type: [{ required: true, message: "请选择合同类型", trigger: "blur" }],
        code: [
          {
            required: true,
            validator: vString("合同编号", 1, 50),
            trigger: "change",
          },
        ],
        name: [
          {
            required: true,
            message: "请输入合同名称",
            trigger: "change",
          },
          {
            min: 1,
            max: 50,
            message: "长度在 1 到 50 个字符",
            trigger: "change",
          },
        ],
        partnerId: [
          { required: true, message: "请选择合同对象", trigger: "change" },
        ],
        signTime: [
          {
            required: true,
            message: "请选择时间",
            trigger: "blur",
          },
        ],
        validityPeriodStart: [
          {
            required: true,
            trigger: "blur",
            message: "请选择合同生效日期",
          },
        ],
        warrantyPeriodEnd: [
          {
            required: false,
            trigger: "blur",
            message: "请输入质保期止",
          },
        ],
        paymentType: [
          { required: true, message: "请选择收付款类型", trigger: "blur" },
        ],
        money: [{ required: true, validator: validatePass, trigger: "change" }],
        signDept: [{ required: true, message: "请输入部门", trigger: "blur" }],
        userIds: [{ required: true, message: "请选择责任人" }],
        overflowFlag: [
          { required: true, message: "请选择是否超额", trigger: "blur" },
        ],
      },
    };
  },
  computed: {
    // 字典 key-value 切换
    contractStatus() {
      return function (val) {
        let res;
        this.dictData.contractLifecycle.forEach((item) => {
          if (item.dictKey == val) {
            res = item.dictValue;
          }
        });
        return res;
      };
    },
    // 字典 key-value 切换
    partnerName() {
      return function (val) {
        let res;
        this.partnerList.forEach((item) => {
          if (item.id == val) {
            res = item.name;
          }
        });
        return res;
      };
    },
  },
  watch: {
    // 项目名称==>合同对象,合同类型
    "ruleForm.projectId": function (newVal, oldVal) {
      if (newVal) {
        this.loadPartnerList(newVal);
        this.loadContractType(newVal);
        this.loadUserList(newVal);
        // 编辑的时候清空:添加oldVal判断是因为进页面的那一次不能触发清空
        if (this.pageMode == 2 && oldVal && newVal) {
          this.$set(this.ruleForm, "type", "");
          this.$set(this.ruleForm, "partnerId", "");
          this.$set(this.ruleForm, "chargeManId", "");
          this.$set(this.form, "partnerId", "");
          this.$set(this.form1, "chargeManId", "");
        }
        // 新增清空
        if (this.pageMode == 1) {
          this.$set(this.ruleForm, "type", "");
          this.$set(this.ruleForm, "partnerId", "");
          this.$set(this.ruleForm, "chargeManId", "");
        }
      }
    },
  },
  methods: {
    //人员选择器
    handleCloseAction() {
      this.dialogUserEditBoxVisible = false;
    },
    handleSubmitAction(val) {
      this.formUserNames = val.nameListString;
      this.ruleForm.chargeManId = val.idListString;
      this.ruleForm.userIds = val.idListString;
      this.remainUserList = val.dataSelectedUsers;
      this.dialogUserEditBoxVisible = false;
    },
    handleEditAction(val) {
      this.formUserNames = val.nameListString;
      this.ruleForm.chargeManId = val.idListString;
      this.ruleForm.userIds = val.idListString;
      this.remainUserList = val.dataSelectedUsers;
      this.dialogUserEditBoxVisible = false;
    },
    addUserBox() {
      this.dialogUserEditBoxVisible = true;
    },
    editUserBox() {
      if (!this.ruleForm.projectId) {
        this.$message({
          type: "warning",
          message: "请先选择一个项目",
        });
        return;
      }
      console.log("this.ruleForm==>", this.ruleForm);
      this.userEditBoxProjectId = this.ruleForm.projectId;
      this.dialogUserEditBoxVisible = true;
    },
    addRelativeContract() {
      let clone = this.deepClone(this.relativeContracts.choosen);
      this.$refs.relativeContract.openDialog(clone);
    },
    relativeContractResult(res) {
      this.relativeContracts.choosen = this.deepClone(res);
      if (this.pageMode == 0 || this.pageMode == 2) {
        //更新关联合同
        let postData = this.ruleForm;
        postData.destIdList = this.relativeContracts.choosen;
        updateLinkContract(postData).then((res) => {
          this.$message.success(res.msg);
        }).catch(err=>{
          console.log('err==>',err);
        });
      }
    },
    // 提交保存
    save() {
      let postData = this.deepClone(this.ruleForm);
      //0.处理富文本
      if (postData.content2) {
        postData.content = Base64.encode(postData.content2);
      }
      postData.chargeManId = postData.userIds;
      console.log("postData==>", postData);
      //1.数据处理
      postData.validityPeriodStart = formatTime(postData.validityPeriodStart);
      postData.signTime = formatTime(postData.signTime);
      if (postData.validityPeriodEnd) {
        postData.validityPeriodEnd = formatTime(postData.validityPeriodEnd);
        if (postData.validityPeriodEnd < postData.validityPeriodStart) {
          this.validityPeriodEndError = "“有效期至”不能小于“生效日期”";
          return;
        } else {
          this.validityPeriodEndError = false;
        }
      } else {
        postData.validityPeriodEnd = "";
      }
      if (postData.warrantyPeriodEnd) {
        postData.warrantyPeriodEnd = formatTime(postData.warrantyPeriodEnd);
      } else {
        postData.warrantyPeriodEnd = "";
      }
      //2.校验
      this.$refs.cttfm.validate((validateRes) => {
        if (!validateRes) {
          return false;
        } else {
          if (!postData.chargeManId) {
            this.$message({ type: "warning", message: "请选择责任人" });
            return false;
          }
          //3.提示
          this.$confirm("是否保存？")
            .then(() => {
              postData.destIdList = this.relativeContracts.choosen;
              //4.提交保存/编辑
              if (this.pageMode == 1) {
                saveContract(postData).then((res) => {
                  this.$message({
                    type: "success",
                    message: res.msg,
                  });
                  this.$emit("closeDialog", "add");
                });
              }
              if (this.pageMode == 2) {
                editContract(postData).then((res) => {
                  this.$message({
                    type: "success",
                    message: res.msg,
                  });
                  this.$emit("closeDialog", "edit");
                });
              }
            })
            .catch((err) => {
              console.log("err:=>", err);
            });
        }
      });
    },
    // 基础方法：加载合同对象
    loadPartnerList(val) {
      this.partnerListLoading = true;
      const params = { id: this.ruleForm.projectId || val };
      getPartnerList(params).then((res) => {
        this.partnerListLoading = false;
        this.partnerList = res.data;
      });
    },
    // 基础方法：加载合同类型
    loadContractType(projectId) {
      getBisDictData({ code: "project_contract_type", projectId }).then(
        (res) => {
          console.log('res.data ==>',res.data);
          this.dictData.contractTypeList = res.data;
        }
      );
    },
    // 加载责任人
    loadUserList(projectId) {
      userList({ projectId }).then((res) => {
        this.userList = res.data;
        this.userList.forEach((element) => {
          if (element.id == this.ruleForm.chargeManId) {
            this.formUserNames = element.realNameAndPhone;
            this.remainUserList = [element];
          }
        });
      });
    },
  },
  created() {
    this.pageLoading = true;
    // 展示需要，先获取合同支付类型和合同状态
    Promise.all([
      getDictData({ code: "contract_payment" }),
      getDictData({ code: "contract_lifecycle" }),
    ])
      .then((res) => {
        this.dictData.paymentTypeList = modifyDictData(res[0].data);
        this.dictData.contractLifecycle = modifyDictData(res[1].data);
        //2: 编辑/查看
        if (this.id) {
          getContractDetail({ id: this.id })
            .then((res) => {
              this.ruleForm = res.data;
              // 转字符串:显示bug
              this.ruleForm.type = this.ruleForm.type + "";
              this.ruleForm.overflowFlag = this.ruleForm.overflowFlag + "";
              this.ruleForm.paymentType = this.ruleForm.paymentType + "";
              // 人员回显
              this.ruleForm.userIds = this.ruleForm.chargeManId;
              this.loadUserList(this.ruleForm.projectId);
              // 富文本
              this.ruleForm.content2 = Base64.decode(this.ruleForm.content);
              this.ruleForm.content2 = this.ruleForm.content2.replace(
                /&amp;nbsp;/gi,
                " "
              );
              // 时间格式
              //赋值 所选合同列表
              this.relativeContracts.choosen = res.data.destIdList;
              this.pageLoading = false;

              // this.cloneChoosen = this.deepClone(this.RelativeContracts.choosen);
            })
            .catch((err) => {
              console.log("err==>", err);
              this.pageLoading = false;
            });
        } else {
          this.pageLoading = false;
        }
      })
      .catch((err) => {
        this.pageLoading = false;
        console.log("err==>", err);
      });
    // 获取项目列表
    getProjectList().then((res) => {
      this.projectList = res.data;
    });
  },
};
</script>

<style scoped lang="scss">
.grid {
  padding: 12px;
  background-color: #fff;
}

.grid-title {
  padding: 30px 20px;

  i {
    font-size: 1.8rem;
    color: #33cc99;
  }

  span {
    font-size: 1.6rem;
    margin-left: 5px;
  }
}

.upload-box {
  padding: 0 20px;
}

.save {
  padding: 20px 50px;
  display: flex;
  justify-content: flex-end;
}
</style>
<style lang="scss">
/* disabled后颜色太淡 */
#plan input:disabled {
  color: #000;
}

#plan .el-radio__label {
  color: #000 !important;
}

#plan {
  .avue-crud .el-input--small input,
  .avue-form .el-input--small input {
    height: 40px;
    line-height: 40px;
  }
  .avue-form__menu {
    display: none;
    padding: 5px 10px 0;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  }
}
</style>
<style lang='scss' scoped>
// ::v-deep .el-dialog {
//   display: flex;
//   flex-direction: column;
//   margin: 0 !important;
//   position: absolute;
//   top: 50%;
//   left: 50%;
//   transform: translate(-50%, -50%);
//   max-height: calc(100% - 1px);
//   max-width: calc(100% - 30px);
// }
// ::v-deep .el-dialog .el-dialog__body {
//   flex: 1;
//   overflow: auto;
// }
</style>
